import { ArrowBigRightIcon, Download } from "lucide-react";
import { GeneralDocumentData } from "../types/generalDocuments";
import { dateTransformer } from "@/common/utils/dateTransformer";
import { strategy as kindStrategy } from "@/features/generalDocuments/constants/kind.constant";
import { Link } from "react-router-dom";
import Button from "../../../common/components/Button";

export class GeneralDocumentTransformer {
  static tableTransformer(operationKlassToCheckPermission?: string) {
    return (documents: GeneralDocumentData[]) => {
      return documents.map((document) => ({
        ...document,
        updated_at: (new Date(document.updated_at)).toLocaleDateString('pt-br'),
        kind: kindStrategy[document.kind as keyof typeof kindStrategy],
        expiration_date: document.expiration_date ? dateTransformer(document.expiration_date) : '',
        actions: (
          <div className="flex items-center gap-4">
            <a href={document.file?.url} download={document.display_name} target="_blank"><Download /></a>
            <Link to={`${document.id}`}>
              <Button className="bg-transparent hover:bg-transparent p-0" operationKlassToCheckPermission={operationKlassToCheckPermission}>
                <ArrowBigRightIcon strokeWidth={1} />
              </Button>
            </Link>
          </div>
        )
      }));
    }
  }
}
